import { setupLayouts } from 'virtual:generated-layouts'
import { ViteSSG } from 'vite-ssg'
import { routes } from 'vue-router/auto-routes'
import App from './App.vue'

import './assets/styles/main.scss'

// https://github.com/antfu/vite-ssg
export const createApp = ViteSSG(
  App,
  {
    // strict: true,
    base: import.meta.env.BASE_URL,
    routes: setupLayouts(routes),
  },
  (ctx) => {
    for (const i of Object.values(
      import.meta.glob<{ install: any }>('./modules/*.ts', { eager: true }))
    ) { i.install?.(ctx) }
  },
)
